import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=62e3b784&"
import script from "./tasks.vue?vue&type=script&lang=js&"
export * from "./tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hugomarcelino/projects/cob/ui-all/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e3b784')) {
      api.createRecord('62e3b784', component.options)
    } else {
      api.reload('62e3b784', component.options)
    }
    module.hot.accept("./tasks.vue?vue&type=template&id=62e3b784&", function () {
      api.rerender('62e3b784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/recordm/fields/tasks.vue"
export default component.exports